import { createSelector } from 'reselect';

// Helpers to support both Immutable.js state (state.get(...)) and plain JS state
const getFromState = (obj, key) => {
  if (!obj) return undefined;
  if (typeof obj.get === 'function') return obj.get(key);
  return obj[key];
};

const selectAuth = state => getFromState(state, 'auth') || {};

const makeSelectLoading = () =>
  createSelector(selectAuth, authState => {
    const v = getFromState(authState, 'loading');
    return v === undefined ? false : v;
  });

const makeSelectError = () =>
  createSelector(selectAuth, authState => getFromState(authState, 'error'));

const makeSelectChangeErrors = () =>
  createSelector(selectAuth, authState => {
    const v = getFromState(authState, 'changeErrors');
    return v && typeof v.toJS === 'function' ? v.toJS() : v || null;
  });

const makeSelectAuthenticated = () =>
  createSelector(selectAuth, authState => {
    const v = getFromState(authState, 'authenticated');
    return !!v;
  });

const makeSelectUser = () =>
  createSelector(selectAuth, authState => {
    const v = getFromState(authState, 'user');
    return v && typeof v.toJS === 'function' ? v.toJS() : v || null;
  });

export {
  selectAuth,
  makeSelectLoading,
  makeSelectAuthenticated,
  makeSelectUser,
  makeSelectError,
  makeSelectChangeErrors,
};
